/* 商品一覧（デザイン案 C）
   一覧・件数・ページ送り・並び替え・絞り込みはすべてサーバー側（Liquid の paginate / sort_by / filter.*）。
   ここでは操作性の補助のみ：並び替え・絞り込みの自動送信、スマホの絞り込みドロワー、
   ブランドページ内のキーワード検索、お気に入り一覧（?fav=1）の表示。 */
(function () {
  'use strict';
  var S = window.SNK;
  var cfgEl = document.getElementById('collCfg');
  if (!S || !cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var $ = function (id) { return document.getElementById(id); };

  /* ---------- 並び替え：選択したらそのまま送信（1 ページ目に戻る） ---------- */
  var sortSel = $('sortSel');
  if (sortSel && sortSel.form) sortSel.addEventListener('change', function () { sortSel.form.submit(); });

  /* ---------- 絞り込み（Search & Discovery のフィルター）：チェックしたら送信 ---------- */
  var ff = $('filterForm');
  if (ff) {
    ff.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'checkbox') ff.submit();
    });
    /* 空欄の価格入力は送らない（filter.v.price.gte= のような空条件を URL に残さない） */
    ff.addEventListener('submit', function () {
      ff.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    });
  }

  /* ---------- キーワード：ブランドページではそのブランドに限定して検索 ---------- */
  var kf = document.querySelector('form[data-kw-form]');
  if (kf) {
    kf.addEventListener('submit', function (e) {
      var inp = kf.querySelector('input[name="q"]');
      var kw = inp ? inp.value.trim() : '';
      if (!kw) { e.preventDefault(); return; }
      var v = kf.getAttribute('data-vendor');
      if (v) { e.preventDefault(); location.href = S.searchUrl(kw, v); }
    });
  }

  /* ---------- スマホ：絞り込みドロワー ---------- */
  (function () {
    var side = $('filter'), bd = $('bd'), opener = $('openF'), closer = $('closeF');
    if (!side || !bd || !opener || !closer) return;
    function drawer(open) {
      side.classList.toggle('open', open);
      bd.classList.toggle('open', open);
      opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) closer.focus(); else opener.focus();
    }
    opener.addEventListener('click', function () { drawer(true); });
    closer.addEventListener('click', function () { drawer(false); });
    bd.addEventListener('click', function () { drawer(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && side.classList.contains('open')) drawer(false); });
    if (location.hash === '#filter' && window.matchMedia('(max-width:768px)').matches) drawer(true);
  })();

  /* ---------- お気に入り一覧（/collections/all?fav=1） ----------
     お気に入りは端末（localStorage）にのみ保存しているため、商品ごとに /products/{handle}?view=card
     （templates/product.card.liquid：商品カード 1 枚の HTML）を取得して並べる。 */
  if (S.qs().get('fav') !== '1') return;
  var grid = $('grid'), empty = $('empty'), cnt = $('collCnt'), pager = $('pager');
  var MAX = 100, CONC = 6;
  function setTitle(t) {
    [$('collTtl'), $('crumbCur')].forEach(function (el) { if (el) el.textContent = t; });
    document.title = t + '｜' + (document.title.split('｜').pop() || '');
  }
  setTitle('お気に入り');
  if (pager) pager.hidden = true;
  document.querySelectorAll('.list-desc, #sortForm, #filter .side-body > form').forEach(function (el) { el.hidden = true; });
  var favs = S.getFav().slice(-MAX).reverse(); /* 新しく追加した順 */
  grid.innerHTML = '';
  if (cnt) cnt.textContent = favs.length;
  function done() {
    var n = grid.children.length;
    if (cnt) cnt.textContent = n;
    empty.innerHTML = 'お気に入りに登録した商品はまだありません。<br>商品ページのハートボタンで登録できます。';
    empty.hidden = n > 0;
  }
  if (!favs.length) { done(); return; }
  var slots = favs.map(function () { var d = document.createElement('div'); d.className = 'card-slot'; grid.appendChild(d); return d; });
  var i = 0, active = 0, finished = 0;
  function next() {
    while (active < CONC && i < favs.length) {
      (function (k) {
        active++;
        fetch(S.url('products/' + encodeURIComponent(favs[k])) + '?view=card', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var t = document.createElement('template');
            t.innerHTML = html;
            var c = t.content.querySelector('.card');
            if (c) slots[k].replaceWith(c); else slots[k].remove();
          })
          .catch(function () { slots[k].remove(); /* 削除・非公開になった商品 */ })
          .then(function () {
            active--; finished++;
            if (finished === favs.length) { done(); S.syncFavButtons(grid); } else next();
          });
      })(i++);
    }
  }
  next();
  /* 一覧上でお気に入りを外したら、その場で消す */
  document.addEventListener('snk:fav', function (e) {
    if (e.detail && !e.detail.on) {
      grid.querySelectorAll('[data-fav]').forEach(function (b) {
        if (b.getAttribute('data-fav') === e.detail.handle) { var c = b.closest('.card'); if (c) c.remove(); }
      });
      done();
    }
  });
})();
